import React from 'react';
import { View } from 'react-native';
import tw from '../styles/tailwind';
import Text from './Text';

// Estatus de adeudo de una vivienda (unit.debt_status en la API). Solo llega a quien tiene
// el permiso `debt_status.view`; sin él, o sin adeudo vencido, no se pinta nada.
export type DebtStatus = {
  is_delinquent: boolean;
  overdue_fees: number;
  overdue_amount: number;
  oldest_overdue_month: string | null;
  delinquent_since: string | null;
};

const money = (n: number) => `$${Math.round(n).toLocaleString('es-MX')}`;

/** "Moroso · 4 cuotas · $8,400" (rojo) o "Debe 1 cuota" (ámbar, aún no es moroso). */
export default function DebtBadge({ status, showAmount = true, style }: { status?: DebtStatus | null; showAmount?: boolean; style?: any }) {
  if (!status || status.overdue_fees <= 0) return null;

  const fees = `${status.overdue_fees} cuota${status.overdue_fees === 1 ? '' : 's'}`;
  const label = status.is_delinquent ? `Moroso · ${fees}` : `Debe ${fees}`;

  return (
    <View
      style={[
        tw.style('self-start flex-row items-center rounded-full px-2 py-0.5', status.is_delinquent ? 'bg-[#FFE4EA]' : 'bg-[#FFF3DC]'),
        style,
      ]}
    >
      <Text style={tw.style('text-[11px] font-600', status.is_delinquent ? 'text-[#D3123F]' : 'text-[#A15C00]')}>
        {label}{showAmount ? ` · ${money(status.overdue_amount)}` : ''}
      </Text>
    </View>
  );
}
